import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full wm-card p-8 rounded-lg text-center" data-testid="payment-cancel-page">
        <XCircle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
        <h2 className="text-2xl font-playfair font-bold text-foreground mb-2">Payment Cancelled</h2>
        <p className="text-muted-foreground mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        <div className="space-y-2">
          <Button
            onClick={() => navigate('/memberships')}
            className="bg-primary text-primary-foreground hover:bg-primary/90 w-full"
            data-testid="try-again-btn"
          >
            Try Again
          </Button>
          <Button
            onClick={() => navigate('/dashboard')}
            variant="outline"
            className="border-border text-foreground hover:bg-white/5 w-full"
            data-testid="back-to-dashboard-btn"
          >
            Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
